module.exports = __webpack_public_path__ + "img/svg/star.2c2042d55333eda76fb1bc301878ede3.svg";